import { css } from '@/styled-system/css';
import { styled } from '@/styled-system/jsx';

export const GalleryButtonGroupLayerOptions = styled('div', {
  base: {
    bottom: {
      base: '8px',
      xxl: '16px',
    },
    color: 'hpxTeal500',
    display: 'flex',
    gap: '8px',
    height: '28px',
    left: {
      base: '26px',
      xxl: '20px',
    },
    position: 'absolute',
    zIndex: 101, // zIndexParent + 1 (PandaCSS cannot use calc on token)
  },
});

export const galleryLayerOptionsStreetMap = css({
  left: {
    base: '26px',
    xxl: '14px',
  },
  top: {
    base: '8px',
    xxl: '32px',
  },
});

export const GalleryButtonGroupButton = styled('button', {
  base: {
    background: 'hpxWhite',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'hpxTeal500',
    borderRadius: '4px',
    cursor: 'pointer',
    display: 'inline-block',
    fontSize: 'sm',
    fontWeight: 'bold',
    paddingTop: '4px',
    paddingRight: '10px',
    paddingBottom: '4px',
    paddingLeft: '10px',
    textAlign: 'center',
    whiteSpace: 'nowrap',
  },
});
